module.exports = __webpack_public_path__ + "img/template-bg.b0787e9b.png";